import instance,{BASE_URL} from "../../services/api";
import toast from 'react-hot-toast';


const ContractViewController =() =>{

    const getErrorMessage = (error) => {
  return (
    error.response?.data?.detail ||   // Django REST Framework style
    error.response?.data?.message ||  // custom backend message
    error.response?.data?.error ||    // another fallback
    error.message ||                  // Axios default
    "Something went wrong!"
  );
};

const getContractTermsAndConditions = () => async (dispatch) => {
    dispatch({ type: "LOADING", payload: true });
    try {
      const response = await instance.get(
        `${BASE_URL}terms-conditions/`
      );

      const jsonString = JSON.stringify(response.data);
      const data = JSON.parse(jsonString);
      dispatch({ type: "GET_CONTRACT_TERMS_AND_CONDITIONS_SUCCESS", payload: data });
      dispatch({ type: "LOADING", payload: false });
    } catch (error) {
      dispatch({ type: "LOADING", payload: false });
      //  const message = getErrorMessage(error);
      dispatch({
        type: "GET_CONTRACT_TERMS_AND_CONDITIONS_FAILURE",
        payload: { error: error }
      });
      // toast.error(message);
    }
  };
 const addContractTermsAndConditions = (reqData) => async (dispatch) => {
    dispatch({ type: "LOADING", payload: true });
    try {
      const response = await instance.post(
        `${BASE_URL}terms-conditions/`,
        reqData
      );

      const jsonString = JSON.stringify(response.data);
      const data = JSON.parse(jsonString);
      dispatch({ type: "ADD_CONTRACT_TERM_AND_CONDITIONS_SUCCESS", payload: data });
      dispatch(getContractTermsAndConditions());
      dispatch({ type: "LOADING", payload: false });
      toast.success("Terms and Conditions added sucessfully");
    } catch (error) {
      dispatch({ type: "LOADING", payload: false });
      const message = getErrorMessage(error);
      dispatch({
        type: "ADD_CONTRACT_TERM_AND_CONDITIONS_FAILURE",
        payload: { error: error },
      });
      toast.error(message);
    }
  };

   const updateContractTermAndConditions = (termId, reqData) => async (dispatch) => {
    dispatch({ type: "LOADING", payload: true });
    try {
      const response = await instance.put(
        `${BASE_URL}terms-conditions/${termId}/`,
        reqData
      );

      const jsonString = JSON.stringify(response.data);
      const data = JSON.parse(jsonString);
      dispatch({ type: "UPDATE_TERMS_AND_CONDITIONS_SUCCESS", payload: data });
      dispatch(getContractTermsAndConditions());
      dispatch({ type: "LOADING", payload: false });
      toast.success("Terms and Conditions updated sucessfully");
    } catch (error) {
      dispatch({ type: "LOADING", payload: false });
      const message = getErrorMessage(error);
      dispatch({
        type: "UPDATE_TERMS_AND_CONDITIONS_FAILURE",
        payload: { error: error },
      });
      toast.error(message);
    }
  };

   const deleteContractTermsAndConditions = (reqData) => async (dispatch) => {
    dispatch({ type: "LOADING", payload: true });
    try {
      const response = await instance.delete(
        `${BASE_URL}terms-conditions/${reqData}/`
      );

      const jsonString = JSON.stringify(response.data);
      const data = JSON.parse(jsonString);
      dispatch({ type: "DELETE_TERMS_AND_CONDITIONS_SUCCESS", payload: data });
      dispatch(getContractTermsAndConditions());
      dispatch({ type: "LOADING", payload: false });
      toast.success("Terms and Conditions deleted sucessfully");
    } catch (error) {
      dispatch({ type: "LOADING", payload: false });
      const message = getErrorMessage(error);
      dispatch({
        type: "DELETE_TERMS_AND_CONDITIONS_FAILURE",
        payload: { error: error },
      });
      toast.error(message);
    }
  };


  const getContract = () => async (dispatch) => {
    dispatch({ type: "LOADING", payload: true });
    try {
      const response = await instance.get(
        `${BASE_URL}contracts/`
      );

      const jsonString = JSON.stringify(response.data);
      const data = JSON.parse(jsonString);
      dispatch({ type: "GET_CONTRACT_SUCCESS", payload: data });
      dispatch({ type: "LOADING", payload: false });
    } catch (error) {
      dispatch({ type: "LOADING", payload: false });
      //  const message = getErrorMessage(error);
      dispatch({
        type: "GET_CONTRACT_FAILURE",
        payload: { error: error }
      });
      // toast.error(message);
    }
  };
 const addContract = (reqData) => async (dispatch) => {
    dispatch({ type: "LOADING", payload: true });
    try {
      const response = await instance.post(
        `${BASE_URL}contracts/`,
        reqData
      );

      const jsonString = JSON.stringify(response.data);
      const data = JSON.parse(jsonString);
      dispatch({ type: "ADD_CONTRACT_SUCCESS", payload: data });
      dispatch(getContract());
      dispatch({ type: "LOADING", payload: false });
      toast.success("Contract added sucessfully");
    } catch (error) {
      dispatch({ type: "LOADING", payload: false });
      const message = getErrorMessage(error);
      dispatch({
        type: "ADD_CONTRACT_FAILURE",
        payload: { error: error },
      });
      toast.error(message);
    }
  };

   const updateContract = (contractId, reqData) => async (dispatch) => {
    dispatch({ type: "LOADING", payload: true });
    try {
      const response = await instance.put(
        `${BASE_URL}contracts/${contractId}/`,
        reqData
      );

      const jsonString = JSON.stringify(response.data);
      const data = JSON.parse(jsonString);
      dispatch({ type: "UPDATE_CONTRACT_SUCCESS", payload: data });
      dispatch(getContract());
      dispatch({ type: "LOADING", payload: false });
      toast.success("Terms and Conditions updated sucessfully");
    } catch (error) {
      dispatch({ type: "LOADING", payload: false });
      const message = getErrorMessage(error);
      dispatch({
        type: "UPDATE_CONTRACT_FAILURE",
        payload: { error: error },
      });
      toast.error(message);
    }
  };

   const deleteContract = (reqData) => async (dispatch) => {
    dispatch({ type: "LOADING", payload: true });
    try {
      const response = await instance.delete(
        `${BASE_URL}contracts/${reqData}/`
      );

      const jsonString = JSON.stringify(response.data);
      const data = JSON.parse(jsonString);
      dispatch({ type: "DELETE_CONTRACT_SUCCESS", payload: data });
      dispatch(getContract());
      dispatch({ type: "LOADING", payload: false });
      toast.success("Terms and Conditions deleted sucessfully");
    } catch (error) {
      dispatch({ type: "LOADING", payload: false });
      const message = getErrorMessage(error);
      dispatch({
        type: "DELETE_CONTRACT_FAILURE",
        payload: { error: error },
      });
      toast.error(message);
    }
  };

  const downloadContractPdf = (contractId) => async (dispatch) => {
  dispatch({ type: "LOADING", payload: true });
  try {
    const response = await instance.get(
      `${BASE_URL}contracts/${contractId}/pdf/`, // <-- adjust URL if needed
      {
        responseType: "blob", // IMPORTANT for file download
      }
    );
    // Create blob URL
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `contract_${contractId}.pdf`); // filename
    document.body.appendChild(link);
    link.click();
    link.remove();
    dispatch({ type: "DOWNLOAD_CONTRACT_PDF_SUCCESS", payload: "PDF downloaded successfully" });
    dispatch({ type: "LOADING", payload: false });
    toast.success("Contract PDF downloaded successfully");
  } catch (error) {
    dispatch({ type: "LOADING", payload: false });
    const message =
      error.response?.data?.detail || "Failed to download contract PDF";
    dispatch({
      type: "DOWNLOAD_CONTRACT_PDF_FAILURE",
      payload: { error },
    });
    toast.error(message);
  }
};

  return{
   getContractTermsAndConditions,
   addContractTermsAndConditions,
   updateContractTermAndConditions,
   deleteContractTermsAndConditions,
   getContract, addContract, updateContract, deleteContract ,
   downloadContractPdf
  }
};

export default ContractViewController;